module.exports = __webpack_public_path__ + "static/img/J1.4679cfa9.jpg";